// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_Tdewt {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._iconToggleSwitch_NggOU {
  color: var(--2d1b8583);
  transition: color var(--animation-quick) ease;
}
._iconToggleSwitch_NggOU svg {
  /* Unlike other icons, this icon is not a square */
  height: auto !important;
}
._iconToggleSwitch_NggOU circle {
  cx: var(--78386a55);
  transition: cx var(--animation-quick) ease;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcIconToggleSwitch-DO_sv5_o.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;EACE,kDAAkD;EAClD,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_Tdewt {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._iconToggleSwitch_NggOU {\n  color: var(--2d1b8583);\n  transition: color var(--animation-quick) ease;\n}\n._iconToggleSwitch_NggOU svg {\n  /* Unlike other icons, this icon is not a square */\n  height: auto !important;\n}\n._iconToggleSwitch_NggOU circle {\n  cx: var(--78386a55);\n  transition: cx var(--animation-quick) ease;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
